import React from "react";
import { ToastContainer, Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
function ResponseMessage() {
  return (
    <ToastContainer
      position="top-center"
      transition={Zoom}
      autoClose={1700}
      closeButton={false}
      hideProgressBar
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
    />
  );
}

export default ResponseMessage;
